module.exports = __webpack_public_path__ + "img/25.919f5eaa.jpg";